/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { PriceCalculator } from '../PriceCalculator'

export class PriceCalculator__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(overrides?: Overrides): Promise<PriceCalculator> {
    return super.deploy(overrides || {}) as Promise<PriceCalculator>
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): PriceCalculator {
    return super.attach(address) as PriceCalculator
  }
  connect(signer: Signer): PriceCalculator__factory {
    return super.connect(signer) as PriceCalculator__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceCalculator {
    return new Contract(address, _abi, signerOrProvider) as PriceCalculator
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_spot',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_strike',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: 'sqrtMaturity',
        type: 'int256'
      },
      {
        internalType: 'uint256',
        name: '_iv',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isPut',
        type: 'bool'
      }
    ],
    name: 'calculateDelta',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_spot',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_strike',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_maturity',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_iv',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isPut',
        type: 'bool'
      }
    ],
    name: 'calculatePrice',
    outputs: [
      {
        internalType: 'uint256',
        name: 'premium',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_spot',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_strike',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_maturity',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_x0',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_x1',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isPut',
        type: 'bool'
      }
    ],
    name: 'calculatePrice2',
    outputs: [
      {
        internalType: 'uint256',
        name: 'premium',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_maturity',
        type: 'uint256'
      }
    ],
    name: 'getSqrtMaturity',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  }
]

const _bytecode =
  '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'
